import { useEffect, useState } from "react";
import { TaxesItemContainer } from "./TaxesItemContainer";
import { useProductsData } from "../menu/products/useProductsData";
import APIExtensions from "../../yoello-lib/modules/API2/APIDefs";
import { useAPIV2 } from "../../yoello-lib/modules/API2/useAPIv2";
import { useSelector } from "react-redux";
import { IReduxAppState } from "../../reducers";
import { useSideTabs } from "../../hooks/useSideTabs";
import { useIsVenueOpen } from "../../hooks/useIsVenueOpen";
import { AlertStatusCard } from "../../yoello-lib/modules/components/UI/Alerts/AlertStatusCard";
import { DisableRouteComponent } from "../util/DisableRouteComponent";
import IVenueSettings from "../../yoello-lib/modules/API/interfaces/IVenueSettings";
import { useTranslation } from "react-i18next";

export function TaxesContainer(props: any) {
  const [taxes, setTaxes] = useState<any[]>([]);
  const [disableEdit, setDisableEdit] = useState(false);
  const { t } = useTranslation();
  useSideTabs(props.tab);
  const { isOpen, isLoading: isOpenLoading } = useIsVenueOpen();
  const selectedId = useSelector(
    (state: IReduxAppState) => state.selectedVenueId
  );

  const { callAPI, isLoading } = useProductsData(
    APIExtensions.taxes,
    selectedId,
    setTaxes
  );
  const { apiData: venueSetting } = useAPIV2<IVenueSettings>(
    APIExtensions.venueSettings,
    {
      yoelloAPIParams: { venue_id: selectedId },
      selectorKeyParams: { venue_id: selectedId },
    }
  );

  useEffect(() => {
    if (venueSetting) {
      if (venueSetting.enabled && (venueSetting.preorders_enabled || isOpen)) {
        setDisableEdit(true);
      }
    }
  }, [venueSetting, isOpen]);

  function renderEntity() {
    return (
      <DisableRouteComponent pageKey={props.tab.key}>
        <>
          {disableEdit && (
            <div style={{ paddingBottom: "1rem" }}>
              {" "}
              <AlertStatusCard
                alertProps={{ severity: "error" }}
                alertMessage={
                  venueSetting?.preorders_enabled
                    ? t('taxes.taxContainer.errorTextPreorder')
                    : t('taxes.taxContainer.errorText')
                }
              />
            </div>
          )}
          <TaxesItemContainer
            isVenueOpen={disableEdit}
            isLoading={isLoading || isOpenLoading}
            taxesList={taxes}
            callTaxesAPI={callAPI}
            venueId={selectedId}
          />
        </>
      </DisableRouteComponent>
    );
  }
  return renderEntity();
}
